<template>
  <div  id="setting_dialog_outer">
    <div>
      <a class="close-button" href="javascript:void(null);" @click="closeDialog">
        <img src="../../assets/shl_personal_setting_close.png">
      </a>
      <div id="pasword_dialog">
        <div class="dialog-title" :style="{color: themeColor}">
          {{user.password == null ? '设置账户登录' : '重置密码'}}
        </div>

        <div class="dialog-content">
          <input v-if="user.password == null" class="input-text"
                 placeholder="请设置登录用户名！"
                 v-model="userName"
                 :style="{borderColor: themeColor}">

          <input v-else class="input-text" type="password"
                 placeholder="请输入原密码！"
                 v-model="userPwd"
                 :style="{borderColor: themeColor}">

          <div>
            <input class="input-text" type="password"
                   placeholder="请输入新密码！"
                   v-model="newUserPwd"
                   :style="{borderColor: themeColor}">
            <password-verifiy style="margin-top: 5px;" v-bind:password="newUserPwd" />
          </div>


          <input class="input-text" type="password"
                 placeholder="请确认新密码！"
                 v-model="doublePwd"
                 :style="{borderColor: themeColor}">

          <input class="input-button" type="button"
                 :value="user.password == null ? '确认设置' : '确认修改'"
                 @click="submitButtonClicked"
                 :style="{backgroundColor: themeColor}">
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import PasswordVerifiy from "../PasswordVerifiy";
  export default {
    name: "BindPassword",
    components: {
      PasswordVerifiy
    },
    props: [
      'theme'
    ],
    data() {
      return {
        title: '重置密码',
        userPwd: '',
        userName: '',
        newUserPwd: '',
        doublePwd: '',
      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      themeColor() {
        if (this.theme == 1) {
          return '#cbb042';
        } else {
          return '#fc1a34';
        }
      },
    },
    mounted() {

    },
    methods: {
      closeDialog() {
        this.$emit('close');
      },

      setPassword() {

        let userName = this.userName.removeBlanks();
        if (userName.length == 0) {
          this.$toast('请输入登录名称！');
          return;
        }

        let newPassword = this.newUserPwd.removeBlanks();
        if (newPassword == '') {
          this.$toast('请输入新密码！');
          return;
        }

        if (newPassword.length < 6) {
          this.$toast('新密码不能少于6位！');
          return;
        }

        let doublePassword = this.doublePwd.removeBlanks();
        if (doublePassword == '') {
          this.$toast('请确认新密码！');
          return;
        }

        if (doublePassword != newPassword) {
          this.$toast('新密码两次输入不一致！');
          return;
        }

        let _this = this;
        let oldPhone = this.user.mobile;
        let params = {
          flag: 5,
          password: newPassword,
          nickname: userName
        };

        this.$store.state.http.ajax.ucProfileUpdate(params,function (data) {
          let code = data.code;
          if (code == 0) {
            _this.$toast('修改成功！');
            let user = _this.user;
            user.nickname = userName;
            user.password = '******';
            _this.$store.commit('setUser', user);

            setTimeout(function () {
              _this.closeDialog();
            }, 500);
          } else {
            if (code == 4) {
              _this.$toast('原密码错误！');
            } else {
              _this.$toast('修改失败！');
            }
          }
        }, function (data) {
          _this.$toast('请求失败，请重试！');
        })
      },

      resetPassword() {
        let password = this.userPwd.removeBlanks();
        if (password == '') {
          this.$toast('请输入原密码！');
          return;
        }

        let newPassword = this.newUserPwd.removeBlanks();
        if (newPassword == '') {
          this.$toast('请输入新密码！');
          return;
        }

        if (newPassword.length < 6) {
          this.$toast('新密码不能少于6位！');
          return;
        }

        if (password == newPassword) {
          this.$toast('新密码不能与现有密码相同！');
          return;
        }

        let doublePassword = this.doublePwd.removeBlanks();
        if (doublePassword == '') {
          this.$toast('请确认新密码！');
          return;
        }

        if (doublePassword != newPassword) {
          this.$toast('新密码两次输入不一致！');
          return;
        }

        let _this = this;
        let oldPhone = this.user.mobile;

        this.$store.state.http.ajax.ucProfileUpdate({
          flag: 2,
          password,
          newPassword
        },function (data) {
          let code = data.code;
          if (code == 0) {
            _this.$toast('修改成功！');
            setTimeout(function () {
              _this.closeDialog();
            }, 500);
          } else {
            if (code == 4) {
              _this.$toast('原密码错误！');
            } else {
              _this.$toast('修改失败！');
            }
          }
        }, function (data) {
          _this.$toast('请求失败，请重试！');
        })
      },

      submitButtonClicked() {

        let password = this.user.password;
        if (password == null) {
          this.setPassword();
        } else {
          this.resetPassword();
        }
      }
    }
  }
</script>

<style scoped>

  #setting_dialog_outer {
    position: fixed !important;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.3);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }

  #setting_dialog_outer > div {
    width: 90%;
    max-width: 800px;
    padding-top: 50px;
    padding-bottom: 80px;
    background-color: white;
    position: relative;
  }

  #setting_dialog_outer .close-button {
    text-decoration: none;
    position: absolute;
    top: 20px;
    right: 15px;
    display: block;
    z-index: 999;
  }

  #setting_dialog_outer .close-button > img {
    height: auto;
    width: 20px;
  }

  #pasword_dialog {
    width: 100%;
    min-height: 150px;
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
  }

  .dialog-title {
    font-size: 1.5rem;
    color: #fc1a34;
    font-weight: bold;
  }

  #pasword_dialog input {
    outline: none;
  }

  #pasword_dialog .dialog-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
  }

  #pasword_dialog .input-text {
    border: solid 1px #fc1a34;
    color: #333;
    text-indent: 15px;
    width: 82vw;
    border-radius: 20px;
    max-width: 400px;
    height: 30px;
    margin-top: 15px;
  }

  #pasword_dialog .input-code-outer {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
  }

  #pasword_dialog .input-code-outer > .input-button {
    width: 40%;
  }

  #pasword_dialog .input-code {
    color: #333;
    border: solid 1px #fc1a34;
    text-indent: 15px;
    width: 50%;
    border-radius: 20px;
    max-width: 250px;
    height: 30px;
    margin-top: 15px;
  }

  #pasword_dialog .input-button {
    background-color: #fc1a34;
    border: none;
    font-size: 1rem;
    border-radius: 20px;
    height: 30px;
    color: white;
    padding: 3px 0;
    font-weight: bold;
    text-align: center;
    width: 80%;
    margin-top: 15px;
  }

  @media screen and (min-width: 768px) {

  }

</style>



// WEBPACK FOOTER //
// src/components/settings/BindPassword.vue